<template>
    <div>
      <div class="row settings-tabs full-height-tabs">
        <div class="col-lg-12 col-md-12">
          <vue-tabs
            ref="tabs"
            direction="vertical"
            class="row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs"
            value="Description"
            @tab-change="handleTabChange"
          >
            <v-tab :title="$t('settingsPages.app')" class="text-left">
              <keep-alive>

                <!-- MODUL ACTIV -->
               <module-locked
                  v-if="isApp && !company.use_app"
                  module="app"
                  icon="📱"
                  title="Modul APP"
                  message="Acest modul nu este activat pentru compania ta."
                  hint="Contactează administratorul pentru activare."
                  action-text="Contact"
                  @action="openSupport"
                />

                <app-form
                  v-if="isApp && company.use_app"
                  :isApp="isApp"
                  :modeldata="model"
                  :defaultData="defaultData"
                />

              </keep-alive>
            </v-tab>
            <v-tab :title="$t('settingsPages.companyWeb')" class="text-left addNewOrder">
              <keep-alive>

                <!-- MODUL ACTIV -->
                <module-locked
                  v-if="isCompanyWeb && !company.use_website"
                  module="website"
                  icon="🌐"
                  :title="$t('general.modules_website_title')"
                  :message="$t('general.modules_website_message')"
                  :hint="$t('general.modules_website_hint')"
                />

                <company-web-form
                  v-if="isCompanyWeb && company.use_website"
                  :isCompanyWeb="isCompanyWeb"
                  :modeldata="websiteData"
                />

              </keep-alive>
            </v-tab>
            <v-tab :title="$t('pages.infoPagesCustom')" class="text-left">
              <keep-alive>
                <custom-info-pages v-if="isInfoPagesCustom" :isInfoPagesCustom="isInfoPagesCustom"></custom-info-pages>
              </keep-alive>
            </v-tab>
            <v-tab :title="$t('pages.infoPages')" class="text-left">
              <keep-alive>
                <info-pages v-if="isInfoPages" :isInfoPages="isInfoPages"></info-pages>
              </keep-alive>
            </v-tab>
            <v-tab :title="$t('settingsPages.homepageSections')" class="text-left">
              <keep-alive>
                <homepage-sections v-if="isHomepageSections" />
              </keep-alive>
            </v-tab>
            <v-tab :title="$t('settingsPages.interactiveTour')" class="text-left">
              <keep-alive>
                <interactive-tour v-if="isInteractiveTour" />
              </keep-alive>
            </v-tab>
            <v-tab :title="$t('settingsPages.blog')" class="text-left">
              <keep-alive>
                <blog v-if="isBlog" />
              </keep-alive>
            </v-tab>
          </vue-tabs>
        </div>
      </div>
    </div>
</template>

  <script>
  import AppForm from '../Settings/Tabs/App.vue'
  import CompanyWebForm from '../Settings/Tabs/CompanyWeb.vue'
  import ModuleLocked from '../../../UIComponents/ModuleLocked.vue'
  import HomepageSections from './HomepageSections.vue'
  import InteractiveTour from './InteractiveTour.vue'
  import Blog from './Blog.vue'
  import CustomInfoPages from '../InfoPagesCustom/CustomInfoPages.vue'
  import InfoPages from '../InfoPages/InfoPages.vue'

  export default {
    components: {
      AppForm,
      CompanyWebForm,
      ModuleLocked,
      HomepageSections,
      InteractiveTour,
      Blog,
      CustomInfoPages,
      InfoPages
    },
    data () {
      return {
        isApp: false,
        isCompanyWeb: false,
        isHomepageSections: false,
        isInteractiveTour: false,
        isBlog: false,
        isInfoPagesCustom: false,
        isInfoPages: false,
        model: {},
        defaultData: {},
        websiteData: []
      }
    },
    computed: {
      company () {
        return (this.userData && this.userData.companies && this.userData.companies[0]) || {}
      }
    },
    mounted () {
      this.userData = JSON.parse(this.$session.get('userData') || '{}')

      this.switchTab()
      this.getModelData()
    },
    methods: {
      resetStates () {
        this.isApp = false
        this.isCompanyWeb = false
        this.isHomepageSections = false
        this.isInteractiveTour = false
        this.isBlog = false
        this.isInfoPagesCustom = false
        this.isInfoPages = false
      },
      switchTab () {
        const index = this.$route.query.tabIndex
        this.$nextTick(() => {
          if (index && this.$refs.tabs) {
            this.$refs.tabs.navigateToTab(parseInt(index))
          }
        })
      },
      getModelData () {
        const token = this.$session.get('token')
        const companyID = this.$session.get('selectedCompany')

        this.apiRequest('/settings/general/' + companyID, 'GET', { token }, (response2) => {
          if (response2.status === true) {
            this.model = response2.data[0]
            this.model.selected_languages = response2.data[0].languages.map(lang => ({
              value: lang.id,
              label: lang.name
            }))
          }
        })

        this.apiRequest('/settings/website', 'GET', {
          token,
          company_id: companyID
        }, (response) => {
          if (response.status === true) {
            this.websiteData = response.data
            console.log('this.websiteData', this.websiteData)
          }
        })
      },
      handleTabChange (tabIndex, newTab, oldTab) {
        this.resetStates()
        this.$router.push(`${this.$route.path}?tabIndex=${tabIndex}`)
        switch (newTab.title) {
          case this.$t('settingsPages.app'):
            this.isApp = true
            break
          case this.$t('settingsPages.companyWeb'):
            this.isCompanyWeb = true
            break
          case this.$t('pages.infoPagesCustom'):
            this.isInfoPagesCustom = true
            break
          case this.$t('pages.infoPages'):
            this.isInfoPages = true
            break
          case this.$t('settingsPages.homepageSections'):
            this.isHomepageSections = true
            break
          case this.$t('settingsPages.interactiveTour'):
            this.isInteractiveTour = true
            break
          case this.$t('settingsPages.blog'):
            this.isBlog = true
            break
          default:
            this.isApp = true
            break
        }
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Online/Online.vue